import { render, staticRenderFns } from "./AllReceivablesTable.vue?vue&type=template&id=1b8e5137&"
import script from "./AllReceivablesTable.vue?vue&type=script&lang=js&"
export * from "./AllReceivablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports